import React, { useState, useEffect, memo, useRef } from "react";
import Select, { components } from "react-select";
import { useHistory } from "react-router";
import { ReactComponent as CustomChartsIcon } from "../../../assets/no-custom-charts.svg";
import {
  customChartEmailSubscription,
  exportCustomChartWithId,
  getCustomChartData,
  getSavedCustomChartData,
  getSavedCustomChartDataWithId,
  publishCustomChartData,
  getUsersForChartSubscription,
  updateChartSubscriptions
} from "../../../actions/radminCustomChartData";
import { useDispatch, useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { Tooltip as MuiTooltip, withStyles } from "@material-ui/core";

import {
  BarChart,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Rectangle,
  Sector,
} from "recharts";
import { Spinner } from "react-bootstrap";
import {
  Button,
  Container,
  LegendList,
  LegendListContainer,
  LegendListItem,
  SelectedItem,
  SelectedItemContainer,
  desiredOrderAppointments,
  desiredOrderEmails,
  desiredOrderNotes,
  desiredOrderPrescriptions,
  desiredOrderRecoHistory,
  desiredOrderRecommendations,
  desiredOrderReports,
  desiredOrderSms,
  desiredOrderFaxes,
  legendWrapperStyle,
  randomColor,
  taskColors,
  desiredOrderPatients,
  desiredOrderReferrers,
  desiredOrderRadiologist,
  desiredOrderRadiologists,
  desiredOrderRecommendationsPie,
} from "./Constants";
import {
  emailColors,
  recommendationStatusColors,
  smsColors,
  COLORS,
} from "./Constants";
import EditModal from "./EditChart";
import moment from "moment";
import { showAlert } from "../../../actions/radminUploads";
import { CSVLink } from "react-csv";
import styled from "styled-components";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  flattenCompareArray,
  flattenIndividualArray,
  groupStatusesByCategory,
  pieChartData,
  pieChartDataTable,
} from "./util";
import { Link } from "react-router-dom";
import { title } from "process";
import { set } from "lodash";

const editIcon = `${process.env.PUBLIC_URL}/${"Edit.svg"}`;

const StyledTableContainer = styled.table`
  & table:last-child tbody tr:last-child {
    border-bottom: none;
  }
`;

const AccordionHeaderFirstColumn = styled.th`
  padding: 10px 30px !important;
  text-align: left;
  border-right: 1px solid #dfdfdf;
  position: sticky;
  z-index: 1;
  background: white;
  left: 0;
  box-shadow: inset 0px -1px #dfdfdf;
`;

const StyledLink = styled(Link)`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 600;
  color: #00aeef;
  margin-right: 18px;
`;

export const Title = styled.div`
  font-family: Roboto Condensed;
  padding-left: 20px;
  padding-right: ${(props) => props.right};
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #000000;
  align-items: center;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const AccordionHeaderRestColumns = styled.th`
  padding: 0px;
  text-align: center;
  border-right: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
`;

const AccordionBodyFirstColumn = styled.td`
  padding: 10px 30px !important;
  text-align: left;
  border-right: 1px solid #dfdfdf;
  position: sticky;
  z-index: 1;
  background: white;
  left: 0;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0px -1px #dfdfdf;
  border-bottom: ${(props) => props.borderBottom};
`;

const AccordionBodyRestColumn = styled.td`
  padding: 0px;
  text-align: center;
  border-right: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
`;

const StyledCsvBtn = styled(CSVLink)`
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  background: #00aeef;
  color: white;
  border-radius: 4px;
  border: 2px solid #00aeef;
  height: 38px;
  font-weight: 600;
  font-size: 14px;
  width: 183px;

  &:hover {
    color: #00aeef;
    background: transparent;
  }
`;

const StyledPublishBtn = styled(Button)`
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: #00aeef;
  background: transparent;
  border-radius: 4px;
  border: 2px solid #00aeef;
  height: 38px;
  font-weight: 600;
  font-size: 14px;
  width: 183px;
`;

const StyledUnpublishBtn = styled(Button)`
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: #cf3131;
  background: transparent;
  border-radius: 4px;
  border: 2px solid #cf3131;
  height: 38px;
  font-weight: 600;
  font-size: 14px;
  width: 89px;

  &:hover {
    color: #cf3131;
    background: transparent;
  }
`;

const StyledApplyBtn = styled(Button)`
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: #00aeef;;
  background: transparent;
  border-radius: 4px;
  border: 2px solid #00aeef;;
  height: 38px;
  font-weight: 600;
  font-size: 14px;
  width: 89px;

  &:hover {
    color: #00aeef;;
    background: transparent;
  }
`;


const CircleGap = styled.div`
  width: 4px;
  height: 4px;
  background: #0c2945;
  border-radius: 50%;
`;

const LabelRow = styled.div`
  display: flex;
  gap: 15px;
  padding: 20px;
  align-items: center;
  justify-content: center;
`;

const LabelRowContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const ChargeLabel = styled.span`
  font-weight: 600;
  font-size: 16px;
`;
const ChargeValue = styled.span`
  font-weight: 600;
  font-family: Roboto Condensed;
  color: ${(props) => props.color};
  font-size: 16px;
`;

const SelectContainerBox = styled.div`
  position: relative;
  z-index: 2;
  width: 227px;
  & div.select__control,
  div.select__value-container {
    height: 38px;
    cursor: pointer;
  }
`;

const SelectContainerBoxMulti = styled.div`
  position: relative;
  z-index: 2;
  width: 227px;
  & div.select__control,
  div.select__value-container {
    cursor: pointer;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

const CustomChartHeader = styled.h1`
  font-family: Roboto Condensed;
  font-weight: 700;
  font-size: 36px;
  color: #0c2945;
  margin-bottom: 0px;
`;

const CustomChartsIconContainer = styled.div`
  position: ${(props) => !props.isImporting && 'absolute'};
  top: ${(props) => !props.isImporting && '50%'};
  left: ${(props) => !props.isImporting && '50%'};
  transform: ${(props) => !props.isImporting && 'translate(-50%, -50%)'};
  display: ${(props) => props.isImporting && 'flex'};
  justify-content: ${(props) => props.isImporting && 'center'};
  text-align: ${(props) => props.isImporting && 'center'};
`;

const CustomChartBox = styled.div`
  min-height: 795px;
  background: white;
  margin-bottom: 30px;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  padding: 30px;
`;

const StyledLabel = styled.label`
  margin-right: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #6d6e6e;
`;

const ChipsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

const options = [
  { value: "never", label: "Never", prevLabel: "Never" },
  { value: "daily", label: "Daily", prevLabel: "Daily" },
  { value: "weekly", label: "Weekly", prevLabel: "Weekly" },
  { value: "monthly", label: "Monthly", prevLabel: "Monthly" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    backgroundColor: "white",
    boxShadow: "none",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  rectangle: {
    width: "80%",
    height: 200,
    backgroundColor: "blue",
    marginTop: 20,
  },
  accordionRoot: {
    width: 0,
    minWidth: "100%",
    overflowX: "auto",
    border: "1px solid #c3c3c3",
    boxShadow: "none",
    "&$expanded": {
      margin: 0,
    },
  },
  summaryRoot: {
    position: "sticky",
    zIndex: "1",
    background: "white",
    left: 0,
  },
}));

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
  } = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  let percentage =
    (percent * 100).toFixed(0) > 0 ? `${(percent * 100).toFixed(0)}%` : "";

  return (
    <g>
      <text
        x={cx}
        y={cy - 30}
        dy={8}
        fill="#0C2945"
        textAnchor={"middle"}
        dominantBaseline="central"
        style={{ fontSize: "20px", lineHeight: "25px", fontWeight: 900 }}
      >
        {percentage}
      </text>
      <text
        x={cx}
        y={cy}
        dy={8}
        textAnchor="middle"
        fill={"#A6ACBE"}
        style={{ fontSize: "10px", lineHeight: "13px", fontWeight: 600 }}
      >
        {payload?.status || payload?.gender}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius}
        outerRadius={outerRadius}
        fill={fill}
      />
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={"middle"}
        dominantBaseline="central"
      >
        {percentage}
      </text>
    </g>
  );
};

const RADIAN = Math.PI / 180;

const truncateLabel = (label, maxLength = 30) =>
  label?.length > maxLength ? `${label?.slice(0, maxLength)}...` : label;

const renderCustomizedLabel = ({ percent, label }) =>
  `${(percent * 100).toFixed(0)}%`;

const StyledTooltip = (props) => {
  const { className, ...other } = props;

  return (
    <MuiTooltip
      {...other}
      PopperProps={{
        className: className,
        style: {
          backgroundColor: "#AEE3F8",
          marginBottom: "20px",
          marginTop: "20px",
          borderRadius: "4px",
          zIndex: 3,
        },
      }}
    />
  );
};

const StyledTooltipWrapper = withStyles(() => ({
  tooltip: {
    backgroundColor: "transparent",
    color: "black!important",
    fontSize: "14px!important",
    fontWeight: 400 + "!important",
    width: "220px",
    padding: "10px",
    textAlign: "center",
    margin: "0px",
    position: "relative",
  },
}))(StyledTooltip);

const IndicatorsContainer = (props) => {
  return (
    <div>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};



const CustomCharts = ({ isImporting = false, chartData, savedCustomChatId }) => {
  const history = useHistory();
  const [customCharts, setCustomCharts] = useState([]);
  const [selectedChart, setSelectedChart] = useState(null);
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [editing, setEditing] = useState({ visible: false, data: {} });
  const [isPublishing, setIsPublishing] = useState(false);
  const [frequency, setFrequency] = useState();
  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const addPermission = rolePermissions
    ?.find((itm) => itm.name === "Custom Charts")
    ?.permissions.find(
      (itm) => itm.codename === "add_customcharts"
    )?.is_authorized;
  const updatePermission = rolePermissions
    ?.find((itm) => itm.name === "Custom Charts")
    ?.permissions.find(
      (itm) => itm.codename === "change_customcharts"
    )?.is_authorized;
    const [timeframeDropdownUpdate, setTimeframeDropdownUpdate] = useState(0);

  const selectedPieChart =
    selectedChart?.selectedValues?.["chart_type"]?.value === "pie";

  const selectedGaugeChart =
    selectedChart?.selectedValues?.["chart_type"]?.value === "gauge";
  const selectedBarChart =
    selectedChart?.selectedValues?.["chart_type"]?.value === "bar";
  const selectedLineChart =
    selectedChart?.selectedValues?.["chart_type"]?.value === "line";
  const selectedCompareFlowType =
    selectedChart?.selectedValues?.["flow_type"]?.value === "compare";
  const selectedIndividualFlowType =
    selectedChart?.selectedValues?.["flow_type"]?.value === "individual";

  const selectedAppointmentsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "appointments";
  const selectedPrescriptionsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "prescriptions";
  const selectedNotesDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "notes";
  const selectedSmsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "sms";
  const selectedEmailsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "emails";
  const selectedRecommendationsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "recommendations";
  const selectedRecoHistoryDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "reco-history";
  const selectedReportsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "reports";
  const selectedRadiologistsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "radiologists";
  const selectedReferrersDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "referrers";
  const selectedFaxDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "faxes";
  const selectedPatientsDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "patients";
    const selectedRecommendationPieDataType =
    selectedChart?.selectedValues?.["data_type"]?.value === "recommendations-pie";

  const noGroupBySelected =
    selectedChart?.selectedValues?.["group_by"]?.length === 0 ||
    !selectedChart?.selectedValues?.["group_by"];

    console.log(selectedCompareFlowType, 'selectedCompareFlowType () =>')

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  const dispatch = useDispatch();
  const classes = useStyles();
  const prevChartIdRef = useRef(null);

  const query = new URLSearchParams(history.location.search);
  const id = query.get("id");
  const [notPublishedChart, setNotPublishedChart] = useState();

  const fetchData = async () => {
    if (chartData?.id === selectedChart?.value) {
      return;
    }
    setSelectedChart(chartData);
    setNotPublishedChart();
    setData([]);
    setFrequency();
    window.analytics.track("Custom-Chart-Option-Click", { ...chartData });

    if (chartData?.id && chartData?.id !== prevChartIdRef.current) {
      setLoadingGraph(true);
      try {
        await dispatch(getSavedCustomChartDataWithId(chartData?.id)).then(
          (res) => {
            if (res) {
              setSelectedChart({
                ...chartData,
                selectedValues: JSON.parse(res?.filters),
                filterValue: JSON.parse(res?.filters)?.timeframe,
                created: res?.created,
                isEditable: res?.is_editable,
                isPublished: res?.is_published,
                published: res?.published,
                publishedBy: res?.published_by,

is_subscribed: res?.is_subscribed,


                title: res?.title,
                value: res?.id
              });
              const updatedUser = options?.find(
                (data) => data?.value === res?.frequency
              );
              setFrequency(updatedUser);

              setData(res?.aggregate);
              setLoadingGraph(false);
            }
          }
        );
      } catch (error) {
        console.error("Error fetching custom chart data:", error);
        setLoadingGraph(false);
      } finally {
        setLoadingGraph(false);
        prevChartIdRef.current = chartData.id;
      }
    }
  };

  useEffect(() => {
    setNotPublishedChart();
    dispatch(getSavedCustomChartData(1)).then((res) => {
      if (res) {
        setCustomCharts(res.results);

        if (id) {
          const matchedObj = res.results.find((itm) =>
            isImporting && chartData?.id
              ? +itm.id === +chartData?.id
              : +itm.id === +id
          );
          if (matchedObj) {
            setNotPublishedChart(false);
            if (!isImporting && !chartData?.id) {
              handleChartSelect({
                value: matchedObj?.id,
                label: matchedObj.title,
                created: matchedObj?.created,
                isEditable: matchedObj?.is_editable,
                isPublished: matchedObj?.is_published,
                isSubscribed: matchedObj?.is_subscribed,
              });
            }
          } else {
            setNotPublishedChart(true);
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    if (isImporting && chartData?.id) {
      fetchData();
    }
  }, [chartData?.id]);

  const Option = (props) => {
    return (
      <>
        <components.Option {...props}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                width: "100%",
              }}
            >
              <span style={{ marginRight: 5 }}>
                <input
                  type="radio"
                  checked={props.isSelected}
                  onChange={() => null}
                  style={{ cursor: "pointer" }}
                />{" "}
              </span>
              <label
                style={{
                  cursor: "pointer",
                  marginBottom: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "160px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                  }}
                >
                  {props.label}
                </span>
                {props.data?.isPublished && !props.data?.isEditable && (
                  <span
                    style={{
                      background: "#c3c3c3",
                      borderRadius: "8px",
                      color: "grey",
                      padding: "2px 10px",
                      fontSize: "10px",
                      fontWeight: 600,
                      position: "absolute",
                      top: "50%",
                      right: 0,
                      transform: "translateY(-50%)",
                    }}
                  >
                    Published
                  </span>
                )}

                   {props.data?.isPublished && props.data?.isSubscribed && !props.data?.isEditable && (
                  <span
                    style={{
                      background: "#c3c3c3",
                      borderRadius: "8px",
                      color: "grey",
                      padding: "2px 10px",
                      fontSize: "10px",
                      fontWeight: 600,
                      position: "absolute",
                      top: "50%",
                      right: 0,
                      transform: "translateY(-50%)",
                    }}
                  >
                    Published & Subscribed
                  </span>
                )}


                   {!props.data?.isPublished && props.data?.isSubscribed && !props.data?.isEditable && (
                  <span
                    style={{
                      background: "#c3c3c3",
                      borderRadius: "8px",
                      color: "grey",
                      padding: "2px 10px",
                      fontSize: "10px",
                      fontWeight: 600,
                      position: "absolute",
                      top: "50%",
                      right: 0,
                      transform: "translateY(-50%)",
                    }}
                  >
                     Subscribed
                  </span>
                )}
               
               
                {props.data?.isEditable && (
                  <img
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "50%",
                      right: 0,
                      transform: "translateY(-50%)",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditing({ visible: true, data: props.data });
                    }}
                    src={editIcon}
                  />
                )}
              </label>
            </div>
          </div>
        </components.Option>
      </>
    );
  };

  const handleEmailSubscription = (selectedOption) => {
    setFrequency(selectedOption);
    dispatch(
      customChartEmailSubscription(
        selectedOption?.value,
        selectedChart?.value || chartData?.id
      )
    ).then((res) => {
      if (res) {
        const updatedUser = options.filter(
          (data) => data?.value === res?.frequency
        );
        setFrequency(updatedUser[0]);
      }
    });
  };

  const handleChartSelect = (selectedOption) => {
    if (selectedOption?.value === selectedChart?.value) {
      return;
    }
    setSelectedChart(selectedOption);
    setNotPublishedChart();
    setData([]);
    setFrequency();
    const searchParams = new URLSearchParams(history.location.search);
    searchParams.delete("id");

    history.push(`${history.location.pathname}?${searchParams.toString()}`);
    window.analytics.track("Custom-Chart-Option-Click", { ...selectedOption });
    if (selectedOption) {
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.set("id", selectedOption?.value);

      history.push(`${history.location.pathname}?${searchParams.toString()}`);
      setLoadingGraph(true);
      dispatch(getSavedCustomChartDataWithId(selectedOption?.value)).then(
        (res) => {
          if (res) {
            setSelectedChart({
              ...selectedOption,
              selectedValues: JSON.parse(res?.filters),
              filterValue: JSON.parse(res?.filters)?.timeframe,
              published: res?.published,
              publishedBy: res?.published_by,
              isSubscribed: res?.is_subscribed,
            });
            const updatedUser = options?.find(
              (data) => data?.value === res?.frequency
            );
            setFrequency(updatedUser);

            setData(res?.aggregate);
            setLoadingGraph(false);
          }
        }
      );
    }
  };

  const chartOptions =
    customCharts.length > 0 &&
    customCharts?.map((chart) => ({
      value: chart?.id,
      label: chart.title,
      created: chart?.created,
      isEditable: chart?.is_editable,
      isPublished: chart?.is_published,
      isSubscribed:chart?.is_subscribed
    }));

  let flattenData = [];
  let uniqueStatuses = [];

  console.log(selectedChart?.selectedValues, 'selectedChart?.selectedValues () =>')

  if (
    selectedChart?.selectedValues?.["group_by"]?.length > 0 &&
    selectedIndividualFlowType &&
    data?.length > 0
  ) {
    const dataObj = flattenIndividualArray(
      selectedChart?.selectedValues,
      data,
      flattenData,
      uniqueStatuses
    );
    flattenData = dataObj.flattenData;
    uniqueStatuses = dataObj.uniqueStatuses;
  }

  const [loadingGraph, setLoadingGraph] = useState(false);

  const renderLegend = (props) => {
    const { payload } = props;

    return (
      <ul style={{ listStyleType: "none", padding: 0 }}>
        {payload.map((entry, index) => {
          const label = entry.payload.payload.label || "Unknown";
          const count = entry.payload.payload.id__count || 0;

          return (
            <li
              key={`legend-item-${index}`}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 5,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  backgroundColor: entry.color,
                  marginRight: 5,
                  borderRadius: "50%",
                }}
              />
              <span>{`${truncateLabel(label)} : ${count}`}</span>
            </li>
          );
        })}
      </ul>
    );
  };

  const chips =
    selectedChart?.selectedValues?.["flow_type"]?.value === "compare"
      ? selectedChart?.selectedValues &&
        Object.keys(selectedChart?.selectedValues)
          .filter(
            (itm) =>
              itm === "additional" ||
              itm === "data_type" ||
              itm === "data_subset" ||
              itm === "group_by"
          )
          ?.map((itm) => {
            if (itm === "data_type") {
              let arr = [];
              for (
                let i = 0;
                i < selectedChart?.selectedValues?.["data_type"].length;
                i++
              ) {
                arr.push({
                  value: [
                    selectedChart?.selectedValues?.["data_type"][i].value,
                  ],
                  label: itm,
                });
              }
              return arr;
            }
            if (itm === "data_subset") {
              let arr = [];
              for (
                let i = 0;
                i < selectedChart?.selectedValues?.["data_type"].length;
                i++
              ) {
                arr.push({
                  value:
                    selectedChart?.selectedValues?.["data_subset"][
                      selectedChart?.selectedValues?.["data_type"][i].value
                    ]?.value,
                  label: itm,
                });
              }
              return arr;
            }
            if (itm === "group_by") {
              let arr = [];
              for (
                let i = 0;
                i < selectedChart?.selectedValues?.["data_type"].length;
                i++
              ) {
                for (
                  let j = 0;
                  j <
                  selectedChart?.selectedValues?.["group_by"][
                    selectedChart?.selectedValues?.["data_type"][i]?.value
                  ]?.length;
                  j++
                ) {
                  arr.push({
                    value:
                      selectedChart?.selectedValues?.["group_by"][
                        selectedChart?.selectedValues?.["data_type"][i].value
                      ][j]?.label,
                    label: itm,
                  });
                }
              }
              return arr;
            }
            if (itm === "additional") {
              let arr = [];
              for (
                let i = 0;
                i < selectedChart?.selectedValues?.["data_type"].length;
                i++
              ) {
                for (const [key, value] of Object.entries(
                  selectedChart?.selectedValues?.additional[
                    selectedChart.selectedValues.data_type[i].value
                  ]
                ) ?? {}) {
                  if (
                    value &&
                    key !== "report__patient__date_of_birth__gte" &&
                    key !== "report__patient__date_of_birth__lte" &&
                    key !== "patient_age_group"
                  ) {
                    if (Array.isArray(value)) {
                      value.map((itm) =>
                        arr.push({
                          value:
                            itm.category === "radiologist" ||
                            itm.category === "user"
                              ? itm.label
                              : itm.value,
                          label:
                            itm.category === "radiologist"
                              ? "Radiologist"
                              : key,
                        })
                      );
                    } else {
                      arr.push({
                        value: value.value,
                        label: key,
                      });
                    }
                  }
                }
              }

              const filteredRecords = arr.filter(
                (record) =>
                  ![
                    "modality_type",
                    "anatomy_type",
                    "report__modality_type",
                    "exam_code_type",
                  ].includes(record.label)
              );

              function getTypeValue(type) {
                const typeRecord = arr.find((record) => record.label === type);
                return typeRecord ? typeRecord.value : null;
              }

              const combinedStrings = filteredRecords.map((record) => {
                let value = record.value;
                if (
                  record.label === "modality" &&
                  getTypeValue("modality_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("modality_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "anatomy" &&
                  getTypeValue("anatomy_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("anatomy_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "report__modality" &&
                  getTypeValue("report__modality_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("report__modality_type") === false
                        ? "Is Not "
                        : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "exam_code" &&
                  getTypeValue("exam_code_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("exam_code_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "initial_exam_date_gte" ||
                  record.label === "initial_exam_date_lte" ||
                  record.label === "nlp_range_start_gte" ||
                  record.label === "nlp_range_start_lte" ||
                  record.label === "nlp_range_end_gte" ||
                  record.label === "nlp_range_end_lte"
                ) {
                  value = moment(value).format("YYYY-MM-DD");
                }
                return { label: record.label, value: value };
              });

              return combinedStrings;
            }
          })
          .flat(10)
      : selectedChart?.selectedValues &&
        Object.keys(selectedChart?.selectedValues)
          .filter((itm) =>
            selectedPieChart || selectedGaugeChart
              ? itm === "additional" ||
                itm === "data_type" ||
                itm === "group_by"
              : itm === "additional" ||
                itm === "data_type" ||
                itm === "data_subset" ||
                itm === "group_by"
          )
          ?.map((itm) => {
            if (itm === "data_type" || itm === "data_subset") {
              return {
                value:
                  selectedChart?.selectedValues[itm]?.value ===
                  "recommendations-pie"
                    ? "Recommendations"
                    : selectedChart?.selectedValues[itm]?.value ===
                      "modality,anatomy"
                    ? "Modality & Anatomy"
                    : selectedChart?.selectedValues[itm]?.value,
                label: itm,
              };
            }
            if (itm === "group_by") {
              let arr = [];
              for (
                let i = 0;
                i < selectedChart?.selectedValues[itm]?.length;
                i++
              ) {
                arr.push({
                  value: selectedChart?.selectedValues[itm][i]?.label,
                  label: itm,
                });
              }
              return arr;
            }
            if (itm === "additional") {
              let arr = [];
              for (const [key, value] of Object.entries(
                selectedChart?.selectedValues?.additional[
                  selectedChart.selectedValues.data_type.value
                ] ?? {}
              )) {
                if (
                  value &&
                  key !== "report__patient__date_of_birth__gte" &&
                  key !== "report__patient__date_of_birth__lte" &&
                  key !== "patient_age_group"
                ) {
                  if (Array.isArray(value)) {
                    value.map((itm) =>
                      arr.push({
                        value:
                          itm.category === "radiologist" ||
                          itm.category === "user"
                            ? itm.label
                            : itm.value,
                        label:
                          itm.category === "radiologist" ? "Radiologist" : key,
                      })
                    );
                  } else {
                    arr.push({
                      value: value.value,
                      label: key,
                    });
                  }
                }
              }

              const filteredRecords = arr.filter(
                (record) =>
                  ![
                    "modality_type",
                    "anatomy_type",
                    "report__modality_type",
                    "exam_code_type",
                  ].includes(record.label)
              );

              function getTypeValue(type) {
                const typeRecord = arr.find((record) => record.label === type);
                return typeRecord ? typeRecord.value : null;
              }

              const combinedStrings = filteredRecords.map((record) => {
                let value = record.value;

                if (
                  record.label === "modality" &&
                  getTypeValue("modality_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("modality_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "anatomy" &&
                  getTypeValue("anatomy_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("anatomy_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "report__modality" &&
                  getTypeValue("report__modality_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("report__modality_type") === false
                        ? "Is Not "
                        : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "exam_code" &&
                  getTypeValue("exam_code_type") !== null
                ) {
                  value =
                    `${
                      getTypeValue("exam_code_type") === false ? "Is Not " : ""
                    }` + capitalizeWords(value);
                } else if (
                  record.label === "initial_exam_date_gte" ||
                  record.label === "initial_exam_date_lte" ||
                  record.label === "nlp_range_start_gte" ||
                  record.label === "nlp_range_start_lte" ||
                  record.label === "nlp_range_end_gte" ||
                  record.label === "nlp_range_end_lte"
                ) {
                  value = moment(value).format("YYYY-MM-DD");
                }
                return { label: record.label, value: value };
              });

              return combinedStrings;
            }
          })
          .flat(10)
          .filter(Boolean);

  function capitalizeWords(str) {
    const words = str?.split(/[_\s]+/);

    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    const capitalizedString = capitalizedWords?.join(" ");

    return capitalizedString;
  }

  const [finalData, setFinalData] = useState([]);
  const [dynamicStatuses, setDynamicStatuses] = useState([]);
  const [statusColors, setStatusColors] = useState({});

  useEffect(() => {
    let flattenedData = [];
    let aggregatedData = [];
    let finalData = [];
    let dynamicStatuses = [];
    setFinalData([]);
    setDynamicStatuses([]);
    if (
      selectedChart?.selectedValues?.["flow_type"]?.value === "compare" &&
      data?.length > 0 &&
      Array.isArray(selectedChart?.selectedValues?.["data_type"]) &&
      !loadingGraph
    ) {
      const dataObj = flattenCompareArray(data, flattenedData);
      flattenedData = dataObj.flattenedData;

      aggregatedData = flattenedData.reduce((acc, item) => {
        if (!acc[item.date]) {
          acc[item.date] = { date: item.date, category: item.category };
        }

        Object.keys(item).forEach((key) => {
          if (key !== "date" && key !== "category") {
            acc[item.date][key] = (acc[item.date][key] || 0) + item[key];
          }
        });
        return acc;
      }, {});

      finalData = Object.values(aggregatedData);

      dynamicStatuses = Array.from(
        new Set(
          finalData.flatMap((item) =>
            Object.keys(item).filter(
              (key) => key !== "date" && key !== "category"
            )
          )
        )
      );

      setFinalData(finalData);
      setDynamicStatuses(dynamicStatuses);
    }
  }, [data, selectedChart?.id, loadingGraph]);

  useEffect(() => {
    const getRandomColor = () => {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };

    if (dynamicStatuses.length > 0) {
      const generatedColors = dynamicStatuses.reduce((acc, status) => {
        acc[status] = getRandomColor();
        return acc;
      }, {});
      setStatusColors(generatedColors);
    }
  }, [dynamicStatuses]);

  const groupedStatuses = groupStatusesByCategory(
    selectedChart?.selectedValues,
    dynamicStatuses,
    statusColors
  );

  console.log('selectedChart () =>', selectedChart)

  const prepareCSVData = () => {
    let csvData = [];

    const getDesiredOrderArray = () => {
  if (selectedPatientsDataType) {
    return desiredOrderPatients;
  }
  if (selectedReferrersDataType) {
    return desiredOrderReferrers;
  }
  if (selectedRadiologistsDataType) {
    return desiredOrderRadiologists;
  }
  if (selectedRecommendationPieDataType) {
    return desiredOrderRecommendationsPie;
  }
  return [];
};

const desiredOrderArray = getDesiredOrderArray();


    if (selectedPieChart || selectedGaugeChart) {
   const csvTable = selectedChart?.selectedValues?.["group_by"]
  ? selectedChart.selectedValues["group_by"]
      .map((itm) => itm.label)
      .sort((a, b) => {
        const indexA = desiredOrderArray.indexOf(a);
        const indexB = desiredOrderArray.indexOf(b);
        
        const finalIndexA = indexA === -1 ? desiredOrderArray.length : indexA;
        const finalIndexB = indexB === -1 ? desiredOrderArray.length : indexB;
        
        return finalIndexA - finalIndexB;
      })
      .join(" - ")
  : "";

      csvData.push([csvTable,'Count']);

      pieChartDataTable(data, selectedChart).forEach((status) => {
        let statusLabel = status?.label;

        if (statusLabel) {
          let row = [statusLabel, status?.id__count];
          csvData.push(row);
        }
      });
    } else if (
      (selectedBarChart || selectedLineChart) &&
      selectedCompareFlowType
    ) {
      selectedChart.selectedValues["data_type"].forEach((chart) => {
        const categoryLabel = selectedChart?.selectedValues?.compare_preceeding
          ? `${chart.label} (${selectedChart?.selectedValues.timeframe.value} v/s Preceding Period)`
          : `${chart.label} (${selectedChart?.selectedValues.timeframe.value})`;
        csvData.push([categoryLabel]);
        let headers =
          !selectedChart?.selectedValues?.["group_by"][chart.value] ||
          selectedChart?.selectedValues?.["group_by"][chart.value]?.length === 0
            ? ["Metric"]
            : [
                selectedChart?.selectedValues?.["group_by"]?.[chart.value]
                  ?.map((itm) => itm.label)
                  ?.sort((a, b) => {
                    let desiredOrderArray = "";
                    if (chart?.value === "prescriptions") {
                      desiredOrderArray = desiredOrderPrescriptions;
                    }
                    if (chart?.value === "appointments") {
                      desiredOrderArray = desiredOrderAppointments;
                    }
                    if (chart?.value === "reco-history") {
                      desiredOrderArray = desiredOrderRecoHistory;
                    }
                    if (chart?.value === "sms") {
                      desiredOrderArray = desiredOrderSms;
                    }
                    if (chart?.value === "emails") {
                      desiredOrderArray = desiredOrderEmails;
                    }
                    if (chart?.value === "notes") {
                      desiredOrderArray = desiredOrderNotes;
                    }
                    if (chart?.value === "recommendations") {
                      desiredOrderArray = desiredOrderRecommendations;
                    }
                    if (chart?.value === "reports") {
                      desiredOrderArray = desiredOrderReports;
                    }
                    if (chart?.value === "faxes") {
                      desiredOrderArray = desiredOrderFaxes;
                    }
                    return (
                      desiredOrderArray.indexOf(a) -
                      desiredOrderArray.indexOf(b)
                    );
                  })
                  .join(" - "),
              ];

        finalData.forEach((item) => {
          if (selectedChart?.selectedValues?.frequency?.value === "months") {
            headers.push(`${moment(item.date).format("MMM YYYY")}`);
            if (selectedChart?.selectedValues?.compare_preceeding) {
              headers.push(
                `${moment(item.date).subtract(1, "year").format("MMM YYYY")}`
              );
            }
          } else if (
            selectedChart?.selectedValues?.frequency?.value === "years"
          ) {
            headers.push(`${item.date}`);
            if (selectedChart?.selectedValues?.compare_preceeding) {
              headers.push(
                `${moment(item.date, "YYYY")
                  .subtract(1, "years")
                  .format("YYYY")}`
              );
            }
          } else if (
            selectedChart?.selectedValues?.frequency?.value === "days"
          ) {
            headers.push(`${item.date}`);
            if (selectedChart?.selectedValues?.compare_preceeding) {
              headers.push(
                `${moment(item.date).subtract(1, "years").format("YYYY-MM-DD")}`
              );
            }
          } else {
            headers.push(`${item.date}`);
            if (selectedChart?.selectedValues?.compare_preceeding) {
              headers.push(
                `${item.date
                  .split(" - ")
                  .map((date) =>
                    moment(date, "DD MMM YYYY")
                      .subtract(1, "year")
                      .format("DD MMM YYYY")
                  )
                  .join(" - ")}`
              );
            }
          }
        });
        csvData.push(headers);

        const statuses =
          chart.value === "faxes"
            ? uniqueFaxes
            : chart.value === "prescriptions"
            ? uniquePrescriptions
            : chart.value === "appointments"
            ? uniqueAppointments
            : chart.value === "reco-history"
            ? uniqueRecoHistory
            : chart.value === "reports"
            ? uniqueReports
            : chart.value === "notes"
            ? uniqueNotes
            : chart.value === "recommendations"
            ? uniqueRecStatues
            : chart.value === "sms"
            ? uniqueSmsStatuses
            : uniqueEmailStatues;

        statuses.forEach((status) => {
          let row = [status];

          finalData.forEach((item) => {
            if (
              !selectedChart?.selectedValues?.["group_by"][chart.value] ||
              selectedChart?.selectedValues?.["group_by"][chart.value]
                ?.length === 0
            ) {
              row.push(
                item[
                  `${
                    chart.value === "reco-history"
                      ? "Reco-history"
                      : chart.label
                  }: ${selectedChart?.selectedValues.timeframe.value}`
                ] ?? 0
              );
            } else {
              row.push(
                item[
                  `${
                    chart.value === "reco-history"
                      ? "Reco-history"
                      : chart.label
                  }: ${
                    selectedChart?.selectedValues.timeframe.value
                  } (${status})`
                ] ?? 0
              );
            }
            if (selectedChart?.selectedValues?.compare_preceeding) {
              if (
                !selectedChart?.selectedValues?.["group_by"][chart.value] ||
                selectedChart?.selectedValues?.["group_by"][chart.value]
                  ?.length === 0
              ) {
                row.push(
                  item[
                    `${
                      chart.value === "reco-history"
                        ? "Reco-history"
                        : chart.label
                    }: Preceding period`
                  ] ?? 0
                );
              } else {
                row.push(
                  item[
                    `${
                      chart.value === "reco-history"
                        ? "Reco-history"
                        : chart.label
                    }: Preceding period (${status})`
                  ] ?? 0
                );
              }
            }
          });

          csvData.push(row);
        });
        csvData.push([], []);
      });
    } else if (
      (selectedBarChart || selectedLineChart) &&
      selectedIndividualFlowType &&
      noGroupBySelected
    ) {
      let headers = ["Reports"];
      data.forEach((item) => {
        headers.push(item.date);
      });
      csvData.push(headers);

      let row = [
        selectedChart?.selectedValues["data_subset"]?.value === "charge"
          ? "Revenue"
          : "Count",
      ];
      data.forEach((item) => {
        row.push(
          selectedChart?.selectedValues["data_subset"]?.value === "charge"
            ? item.data?.[0]?.id__count?.toLocaleString("en-US") || "0"
            : item.data?.[0]?.id__count || "0"
        );
      });
      csvData.push(row);
    } else {
      let headers = [
        selectedChart?.selectedValues?.["group_by"]
          .map((itm) => itm.label)
          ?.sort((a, b) => {
            let desiredOrderArray = "";
            if (selectedPrescriptionsDataType) {
              desiredOrderArray = desiredOrderPrescriptions;
            }
            if (selectedAppointmentsDataType) {
              desiredOrderArray = desiredOrderAppointments;
            }
            if (selectedRecoHistoryDataType) {
              desiredOrderArray = desiredOrderRecoHistory;
            }
            if (selectedSmsDataType) {
              desiredOrderArray = desiredOrderSms;
            }
            if (selectedEmailsDataType) {
              desiredOrderArray = desiredOrderEmails;
            }
            if (selectedNotesDataType) {
              desiredOrderArray = desiredOrderNotes;
            }
            if (selectedRecommendationsDataType) {
              desiredOrderArray = desiredOrderRecommendations;
            }
            if (selectedReportsDataType) {
              desiredOrderArray = desiredOrderReports;
            }
            if (selectedFaxDataType) {
              desiredOrderArray = desiredOrderFaxes;
            }
            return desiredOrderArray.indexOf(a) - desiredOrderArray.indexOf(b);
          })
          .join(" - "),
      ];
      flattenData.forEach((item) => {
        headers.push(item.date);
      });
      csvData.push(headers);

      uniqueStatuses.forEach((status) => {
        let row = [status];
        flattenData.forEach((item) => {
          row.push(item[status] || "0");
        });
        csvData.push(row);
      });
    }

    return csvData;
  };

  let recStatuses = [];
  let smsStatuses = [];
  let emailStatuses = [];
  let notesStatuses = [];
  let reportsStatuses = [];
  let recoHistoryStatuses = [];
  let prescriptionStatuses = [];
  let appointmentStatuses = [];
  let faxesStatuses = [];

  Object.keys(groupedStatuses).map((category) => {
    if (category.includes("Recommendations:")) {
      recStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Sms:")) {
      smsStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Emails:")) {
      emailStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Notes:")) {
      notesStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Reports:")) {
      reportsStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Reco-history:")) {
      recoHistoryStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Prescriptions:")) {
      prescriptionStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Appointments:")) {
      appointmentStatuses.push(...groupedStatuses[category]);
    }
    if (category.includes("Faxes:")) {
      faxesStatuses.push(...groupedStatuses[category]);
    }
  });

  let uniqueRecStatues = [
    ...new Set(recStatuses.map((item) => item.status).filter((itm) => itm)),
  ];
  let uniqueEmailStatues = [
    ...new Set(emailStatuses.map((item) => item.status).filter((itm) => itm)),
  ];
  let uniqueSmsStatuses = [
    ...new Set(smsStatuses.map((item) => item.status).filter((itm) => itm)),
  ];

  let uniqueNotes = [
    ...new Set(notesStatuses.map((item) => item.status).filter((itm) => itm)),
  ];
  let uniqueReports = [
    ...new Set(reportsStatuses.map((item) => item.status).filter((itm) => itm)),
  ];

  let uniqueRecoHistory = [
    ...new Set(
      recoHistoryStatuses.map((item) => item.status).filter((itm) => itm)
    ),
  ];

  let uniquePrescriptions = [
    ...new Set(
      prescriptionStatuses.map((item) => item.status).filter((itm) => itm)
    ),
  ];
  let uniqueAppointments = [
    ...new Set(
      appointmentStatuses.map((item) => item.status).filter((itm) => itm)
    ),
  ];

  let uniqueFaxes = [
    ...new Set(faxesStatuses.map((item) => item.status).filter((itm) => itm)),
  ];

    const [selectedValues, setSelectedValues] = useState([])
  const [users, setUsers] = useState([]);

    useEffect(() => {
      if((selectedChart?.value  || chartData?.id) &&  (selectedChart?.isEditable) ){
      
      dispatch(getUsersForChartSubscription(selectedChart?.value || chartData?.id)).then((res) => {
        if (res) {
          const frequencies = ["daily", "weekly", "monthly", "never"];

            const groupedOptions = res?.results?.map((user) => ({
    label: `${user.first_name} ${user.last_name}`.trim(),
    options: frequencies.map((freq) => ({
      label: freq.charAt(0).toUpperCase() + freq.slice(1),
      value: `${user.id}__${freq}`,
      userId: user.id,
      frequency: freq,
                userLabel: `${user.first_name} ${user.last_name}`.trim(),

    })),
  }));
          setUsers(
          groupedOptions
          );
          const preselected = res.results
          .filter((u) => u.subscription_frequency)
          .map((u) => ({
            label:
              `${u.first_name} ${u.last_name}`.trim() +
              " - " +
              u.subscription_frequency.charAt(0).toUpperCase() +
              u.subscription_frequency.slice(1),
            value: `${u.id}__${u.subscription_frequency}`,
            userId: u.id,
            frequency: u.subscription_frequency,
            userLabel: `${u.first_name} ${u.last_name}`.trim(),
          }));

        setSelectedValues(preselected);
        }
      });
    }
    }, [selectedChart?.value, chartData?.id]);
 // 🔹 Handle selection changes
  const handleChange = (newValues) => {
    if (!newValues) {
      setSelectedValues([]);
      return;
    }

    // Ensure one frequency per user
    const filtered = [];
    const userMap = new Map();

    newValues.forEach((option) => {
      if (!userMap.has(option.userId)) {
        userMap.set(option.userId, option);
        filtered.push(option);
      } else {
        const index = filtered.findIndex((v) => v.userId === option.userId);
        if (index !== -1) filtered[index] = option;
      }
    });

    // Update label to show "User - Frequency" in chip
    const updated = filtered.map((opt) => ({
      ...opt,
      label: `${opt.userLabel} - ${opt.frequency.charAt(0).toUpperCase() + opt.frequency.slice(1)}`,
    }));

    setSelectedValues(updated);
  };
  

    // 🔹 Custom MultiValueLabel (to show in chip)
  const MultiValueLabel = (props) => {
    return (
      <components.MultiValueLabel {...props}>
        {props.data.userLabel} -{" "}
        {props.data.frequency.charAt(0).toUpperCase() +
          props.data.frequency.slice(1)}
      </components.MultiValueLabel>
    );
  };

  
  const styles = {
    option: (styles) => ({
      ...styles,
      fontSize: "14px",
    }),
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "white",
    }),
    multiValue: (styles, { data }) => ({
      ...styles,
      borderRadius: "25px",
      backgroundColor: "#EEEEEE",
      color: "#A1A1A1",
      padding: "4px 10px",
    }),
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#A1A1A1",
      fontSize: "10px",
    }),
  };


  const [loading, setLoading] = useState(false);


   const handleApply = async () => {
    if (!selectedValues.length) return;

    const chartId = selectedChart?.value || chartData?.id;
    const subscription_details = selectedValues.map((v) => ({
      subscriber_id: v.userId.replace(/-/g, ""), // remove dashes if needed
      frequency: v.frequency,
    }));

    const payload = { subscription_details };

    try {
      setLoading(true);
      await dispatch(updateChartSubscriptions(chartId, payload));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const exportHandler = async() => {
    const payloadData = {
      chart_builder_filter: selectedChart?.value
    }
   selectedChart?.value && await dispatch(exportCustomChartWithId(payloadData))
  };

  return (
    <Container
      isImporting={isImporting}
      isTimeGraph={selectedBarChart || selectedLineChart}
      style={{
        padding: !isImporting && "22px 33px 20px 20px",
        height: !isImporting && "100%",
      }}
    >
      {!isImporting && !chartData?.id ? (
        <HeaderRow>
          <CustomChartHeader>Custom Charts</CustomChartHeader>
          <Button
            onClick={() => {
              if ((permission && addPermission) || !permission) {
                history.push(`/auth/radAdmin/custom/charts/create`);
                window.analytics.track("Custom-Charts-Create-Click");
              } else {
                dispatch(
                  showAlert(
                    "danger",
                    "Error",
                    `You don't have permission to create custom chart`
                  )
                );
              }
            }}
          >
            Create Custom Chart
          </Button>
        </HeaderRow>
      ) : null}

      {!isImporting && id && !selectedChart && !notPublishedChart ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {" "}
          <Spinner animation="border" role="status" size="sm" />
        </div>
      ) : !isImporting && customCharts?.length === 0 ? (
        <CustomChartsIconContainer>
          <CustomChartsIcon />
        </CustomChartsIconContainer>
      ) : (
        <CustomChartBox>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "10px",
            }}
          >
            {isImporting && chartData?.id ? (
              <Title right="32px">Custom Chart</Title>
            ) : (
              <StyledLabel htmlFor="customChartDropdown">
                SAVED CUSTOM CHARTS
              </StyledLabel>
            )}

            <div
              style={{
                display: "flex",
                ...(isImporting &&
                  chartData?.id && {
                    flexDirection: "column",
                    gap: "8px",
                  }),
                justifyContent:
                  isImporting && chartData?.id ? "flex-end" : "space-between",
                width: "100%",
              }}
            >
              {isImporting && chartData?.id ? (
                <StyledLink
                  to={`/auth/radAdmin/custom/charts/view?id=${chartData?.id}`}
                >
                  View Chart
                </StyledLink>
              ) : (
                <div style={{ minWidth: "350px" }}>
                  <Select
                    components={{ Option }}
                    id="customChartDropdown"
                    options={chartOptions}
                    value={selectedChart}
                    onChange={handleChartSelect}
                    isClearable={true}
                  />
                </div>
              )}

              {selectedChart && (
                <ChipsContainer>
                  {chips?.map((itm) => {
                    return (
                      <SelectedItemContainer>
                        <SelectedItem>
                          {capitalizeWords(itm?.label)} :{" "}
                          {capitalizeWords(String(itm?.value))}
                        </SelectedItem>
                      </SelectedItemContainer>
                    );
                  })}
                </ChipsContainer>
              )}
            </div>
          </div>
          {notPublishedChart ? (
            <div>
              <p style={{ marginTop: "100px", textAlign: "center" }}>
                The chart you are trying to view does not exist or has not been
                published yet. Please select a different chart.
              </p>
            </div>
          ) : loadingGraph ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              {" "}
              <Spinner animation="border" role="status" size="sm" />
            </div>
          ) : (
            customCharts.length > 0 &&
            selectedChart && (
              <>
                <h4 style={{ textAlign: "center" }}>
                  {isImporting && chartData?.id
                    ? selectedChart?.title
                    : selectedChart?.label}
                </h4>
                {selectedChart?.isPublished && !selectedChart?.isEditable && (
                  <>
                    <LabelRow>
                      <LabelRowContainer>
                        <ChargeLabel>Published By:</ChargeLabel>
                        <ChargeValue color="#64C67C">
                          {selectedChart?.publishedBy?.email}
                        </ChargeValue>
                      </LabelRowContainer>
                      <CircleGap />

                      <LabelRowContainer>
                        <ChargeLabel>Published:</ChargeLabel>
                        <ChargeValue color="#7F0CDA">
                          {moment(selectedChart?.published).fromNow()}
                        </ChargeValue>
                      </LabelRowContainer>
                    </LabelRow>
                  </>
                )}
                <div style={{ height: "400px", marginBottom: "30px" }}>
                  {!selectedChart?.selectedValues?.[
                    "chart_type"
                  ] ? null : selectedBarChart ? (
                    selectedCompareFlowType ? (
                      <>
                        <ResponsiveContainer width="100%" height="100%">
                          <BarChart
                            data={finalData}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip wrapperStyle={{ zIndex: 2 }} />
                            {dynamicStatuses.map((status) => (
                              <Bar
                                key={status}
                                dataKey={status}
                                fill={statusColors[status]}
                              />
                            ))}
                          </BarChart>
                        </ResponsiveContainer>
                      </>
                    ) : noGroupBySelected ? (
                      <ResponsiveContainer width="100%" height="100%">
                        {
                          <BarChart
                            width={500}
                            height={300}
                            data={data?.map((item) => ({
                              date: item.date,
                              id__count: item.data?.[0]?.id__count,
                            }))}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar
                              dataKey="id__count"
                              fill="#8884d8"
                              activeBar={
                                <Rectangle fill="pink" stroke="blue" />
                              }
                              barSize={40}
                            />
                          </BarChart>
                        }
                      </ResponsiveContainer>
                    ) : (
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                          width={500}
                          height={300}
                          data={flattenData}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <Tooltip wrapperStyle={{ zIndex: 2 }} />
                          <Legend />
                          {uniqueStatuses.map((status, index) => (
                            <Bar
                              key={index}
                              dataKey={status}
                              name={status}
                              barSize={40}
                              fill={
                                selectedFaxDataType
                                  ? randomColor(index)
                                  : selectedReportsDataType
                                  ? randomColor(index)
                                  : selectedAppointmentsDataType
                                  ? randomColor(index)
                                  : selectedPrescriptionsDataType
                                  ? randomColor(index)
                                  : selectedRecommendationsDataType &&
                                    selectedChart?.selectedValues?.["group_by"]
                                      ?.map((itm) => itm?.value)
                                      .join(",") === "status"
                                  ? recommendationStatusColors(status)
                                  : selectedRecommendationsDataType
                                  ? randomColor(index)
                                  : selectedNotesDataType &&
                                    selectedChart?.selectedValues?.["group_by"]
                                      ?.map((itm) => itm.value)
                                      .join(",") === "task"
                                  ? taskColors(status)
                                  : selectedNotesDataType
                                  ? randomColor(index)
                                  : selectedRecoHistoryDataType
                                  ? randomColor(index)
                                  : selectedSmsDataType
                                  ? randomColor(index)
                                  : emailColors(status)
                              }
                            />
                          ))}
                        </BarChart>
                      </ResponsiveContainer>
                    )
                  ) : selectedLineChart ? (
                    selectedCompareFlowType ? (
                      <ResponsiveContainer width="100%" height="100%">
                        {selectedChart?.selectedValues["data_subset"]?.value ===
                        "charge" ? (
                          <LineChart
                            width={500}
                            height={300}
                            data={data.map((item) => ({
                              date: item.date,
                              charge_amount_sum: item.data[0].id__count,
                            }))}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip
                              formatter={(value) =>
                                `$${value?.toLocaleString("en-US")}`
                              }
                            />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="charge_amount_sum"
                              stroke="#8884d8"
                              activeDot={{ r: 8 }}
                            />
                          </LineChart>
                        ) : (
                          <LineChart
                            width={500}
                            height={300}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="date"
                              allowDuplicatedCategory={false}
                            />
                            <YAxis />
                            <Tooltip wrapperStyle={{ zIndex: 2 }} />
                            {dynamicStatuses.map((status) => (
                              <Line
                                dataKey={status}
                                stroke={statusColors[status]}
                                data={finalData}
                                strokeDasharray="10 10"
                                dot={false}
                                type="monotone"
                              />
                            ))}
                          </LineChart>
                        )}
                      </ResponsiveContainer>
                    ) : noGroupBySelected ? (
                      <ResponsiveContainer width="100%" height="100%">
                        {selectedChart?.selectedValues["data_subset"]?.value ===
                        "charge" ? (
                          <LineChart
                            width={500}
                            height={300}
                            data={data?.map((item) => ({
                              date: item.date,
                              charge_amount_sum: item.data?.[0]?.id__count,
                            }))}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip
                              formatter={(value) =>
                                `$${value?.toLocaleString("en-US")}`
                              }
                            />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="charge_amount_sum"
                              stroke="#8884d8"
                              activeDot={{ r: 8 }}
                            />
                          </LineChart>
                        ) : (
                          <LineChart
                            width={500}
                            height={300}
                            data={data?.map((item) => ({
                              date: item.date,
                              id__count: item.data?.[0]?.id__count,
                            }))}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="id__count"
                              stroke="#8884d8"
                              activeDot={{ r: 8 }}
                            />
                          </LineChart>
                        )}
                      </ResponsiveContainer>
                    ) : (
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={flattenData}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <Tooltip wrapperStyle={{ zIndex: 2 }} />
                          <Legend />

                          {uniqueStatuses.map((status, index) => (
                            <Line
                              key={index}
                              dataKey={status}
                              name={status}
                              stroke={
                                selectedReportsDataType
                                  ? randomColor(index)
                                  : selectedAppointmentsDataType
                                  ? randomColor(index)
                                  : selectedPrescriptionsDataType
                                  ? randomColor(index)
                                  : selectedRecommendationsDataType &&
                                    selectedChart?.selectedValues?.["group_by"]
                                      ?.map((itm) => itm?.value)
                                      .join(",") === "status"
                                  ? recommendationStatusColors(status)
                                  : selectedRecommendationsDataType
                                  ? randomColor(index)
                                  : selectedNotesDataType &&
                                    selectedChart?.selectedValues?.["group_by"]
                                      ?.map((itm) => itm.value)
                                      .join(",") === "task"
                                  ? taskColors(status)
                                  : selectedNotesDataType
                                  ? randomColor(index)
                                  : selectedRecoHistoryDataType
                                  ? randomColor(index)
                                  : selectedSmsDataType
                                  ? randomColor(index)
                                  : emailColors(status)
                              }
                            />
                          ))}
                        </LineChart>
                      </ResponsiveContainer>
                    )
                  ) : selectedPieChart ? (
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={600} height={600}>
                        <Pie
                          data={pieChartData(data)}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          label={renderCustomizedLabel}
                          outerRadius={180}
                          fill="#8884d8"
                          dataKey="id__count"
                        >
                          {pieChartData(data).map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend
                          iconSize={10}
                          width={120}
                          height={140}
                          layout="vertical"
                          verticalAlign="middle"
                          wrapperStyle={legendWrapperStyle}
                          iconType={"circle"}
                          content={renderLegend}
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  ) : (
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart width={600} height={600}>
                        <Pie
                          activeIndex={activeIndex}
                          activeShape={renderActiveShape}
                          dataKey="id__count"
                          startAngle={180}
                          endAngle={0}
                          data={pieChartData(data)}
                          cy={240}
                          cx={"50%"}
                          outerRadius={220}
                          innerRadius={50}
                          fill="#8884d8"
                          label={renderCustomizedLabel}
                          labelLine={false}
                          onMouseEnter={onPieEnter}
                          animationDuration={0}
                          strokeWidth={0}
                        >
                          {pieChartData(data)?.map((entry, index) => (
                            <Cell
                              key={`cell-${index}-${activeIndex}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Legend
                          iconSize={10}
                          width={120}
                          height={140}
                          layout="vertical"
                          verticalAlign="middle"
                          wrapperStyle={legendWrapperStyle}
                          iconType={"circle"}
                          content={renderLegend}
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  )}
                </div>
                {selectedCompareFlowType &&
                  data?.length > 0 &&
                  Array.isArray(selectedChart?.selectedValues?.["data_type"]) &&
                  !loadingGraph &&
                  Object.keys(groupedStatuses).length > 0 && (
                    <div style={{ marginBottom: "50px" }}>
                      <table>
                        <thead>
                          <tr>
                            <th>Category</th>
                            <th>Legend</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(groupedStatuses).map((category) => (
                            <tr key={category}>
                              <td>{category}</td>
                              <td>
                                {groupedStatuses[category]
                                  .filter((itm) => itm.status)
                                  .map((statusInfo, index) => (
                                    <span
                                      key={index}
                                      style={{
                                        display: "inline-block",
                                        margin: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          backgroundColor: statusInfo.color,
                                          width: "12px",
                                          height: "12px",
                                          display: "inline-block",
                                          marginRight: "6px",
                                        }}
                                      />
                                      {statusInfo.status}
                                    </span>
                                  ))}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div style={{ display: "flex", gap: "30px", marginBottom:'10px'}}>
                  <StyledCsvBtn
                    data={prepareCSVData()}
                    filename={`${
                      isImporting && chartData?.id
                        ? selectedChart?.title
                        : selectedChart?.label
                    }.csv`}
                    target="_blank"
                  >
                    Download as CSV
                  </StyledCsvBtn>

                  {!selectedChart?.isPublished && selectedChart?.isEditable && (
                    <>
                      <StyledTooltipWrapper
                        placement="top"
                        title={
                          "Publishing will give other users within your provider access to view this chart. They cannot edit it."
                        }
                      >
                        <StyledPublishBtn
                          onClick={() => {
                            if (
                              (permission && updatePermission) ||
                              !permission
                            ) {
                              setIsPublishing(true);
                              dispatch(
                                publishCustomChartData(
                                  selectedChart?.value,
                                  true
                                )
                              ).then((res) => {
                                setIsPublishing(false);
                                if (res) {
                                  setSelectedChart({
                                    value: res?.id,
                                    label: res?.title,
                                    selectedValues: JSON.parse(res?.filters),
                                    filterValue: JSON.parse(res?.filters)
                                      ?.timeframe,
                                    created: res?.created,
                                    isEditable: res?.is_editable,
                                    isPublished: res?.is_published,
                                    published: res?.published,
                                    publishedBy: res?.published_by,
                                    title: res?.title,
                                  });
                                  setCustomCharts((prev) =>
                                    prev.map((itm) =>
                                      itm.id === res.id
                                        ? {
                                            created: res?.created,
                                            filters: res?.filters,
                                            id: res?.id,
                                            is_editable: res?.is_editable,
                                            is_published: res?.is_published,
                                            published: res?.published,
                                            title: res?.title,
                                          }
                                        : itm
                                    )
                                  );
                                }
                              });
                            } else {
                              dispatch(
                                showAlert(
                                  "danger",
                                  "Error",
                                  `You don't have permission to publish custom chart`
                                )
                              );
                            }
                          }}
                        >
                          {isPublishing ? (
                            <Spinner
                              animation="border"
                              role="status"
                              size="sm"
                            />
                          ) : (
                            "Publish"
                          )}
                        </StyledPublishBtn>
                      </StyledTooltipWrapper>
                    </>
                  )}

                  {selectedChart?.isPublished && selectedChart?.isEditable && (
                    <StyledUnpublishBtn
                      onClick={() => {
                        if ((permission && updatePermission) || !permission) {
                          setIsPublishing(true);
                          dispatch(
                            publishCustomChartData(selectedChart?.value, false)
                          ).then((res) => {
                            setIsPublishing(false);
                            if (res) {
                              setSelectedChart({
                                value: res?.id,
                                label: res?.title,
                                selectedValues: JSON.parse(res?.filters),
                                filterValue: JSON.parse(res?.filters)
                                  ?.timeframe,
                                created: res?.created,
                                isEditable: res?.is_editable,
                                isPublished: res?.is_published,
                                published: res?.published,
                                publishedBy: res?.published_by,
                                title: res?.title,
                              });
                              setCustomCharts((prev) =>
                                prev.map((itm) =>
                                  itm.id === res.id
                                    ? {
                                        created: res?.created,
                                        filters: res?.filters,
                                        id: res?.id,
                                        is_editable: res?.is_editable,
                                        is_published: res?.is_published,
                                        published: res?.published,
                                        title: res?.title,
                                      }
                                    : itm
                                )
                              );
                            }
                          });
                        } else {
                          dispatch(
                            showAlert(
                              "danger",
                              "Error",
                              `You don't have permission to unpublish custom chart`
                            )
                          );
                        }
                      }}
                    >
                      {isPublishing ? (
                        <Spinner animation="border" role="status" size="sm" />
                      ) : (
                        "Unpublish"
                      )}
                    </StyledUnpublishBtn>
                  )}

{
   !selectedChart?.isEditable ?  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginTop: "-30px",
                    }}
                  >
                    <StyledLabel htmlFor="customChartDropdown">
                      SUBSCRIPTION FREQUENCY
                    </StyledLabel>
                    <SelectContainerBox>
                      <Select
                        components={{ IndicatorsContainer, Option }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={
                          frequency
                            ? options
                            : options.filter((data) => data.value !== "never")
                        }
                        key={timeframeDropdownUpdate}
                        value={frequency}

                        onChange={(value) => {
                          if ((permission && updatePermission) || !permission) {
                            handleEmailSubscription(value);
                          } else {
                            setTimeout(() => {
                              setTimeframeDropdownUpdate(prev => prev + 1);
                            }, 0);
                            dispatch(
                              showAlert(
                                "danger",
                                "Error",
                                `You don't have permission to update subscription frequency`
                              )
                            );
                          }
                        }}
                        styles={{
                          control: (styles) => ({
                            ...styles,
                            backgroundColor: "white",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#252525",
                          }),
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                            cursor: "pointer",
                            overflowX: "hidden",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#828282",
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Open Sans",
                            marginLeft: "0px",
                          }),
                        }}
                      />
                    </SelectContainerBox>
                  </div> 

                  :     <div style={{display:'flex', gap:'30px'}}>
                  
                   <div
                              style={{ display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginTop: "-30px",}}
                            >
                                <StyledLabel>Manage Users Subscriptions</StyledLabel>
                                                              <SelectContainerBoxMulti>

                           <Select
                   filterOption={(option, inputValue) =>
  option.data?.userLabel?.toLowerCase().includes(inputValue.toLowerCase())
}

          classNamePrefix="select"
          options={users}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          value={selectedValues}
          onChange={handleChange}
          components={{ IndicatorsContainer, MultiValueLabel, Option }}
       styles={styles}
        />
                              </SelectContainerBoxMulti>
                            </div>
                    <StyledApplyBtn
        onClick={handleApply}
        disabled={loading}
      
      >
        {loading ? "Applying..." : "Apply"}
      </StyledApplyBtn>
                  </div>  
}
 {
                    selectedChart?.selectedValues?.flow_type?.value !== 'compare' &&
                    <Button onClick={() => exportHandler()}>
                       Export
                     </Button>
                  }
                    


                
                </div>

                {(selectedBarChart || selectedLineChart) &&
                  selectedCompareFlowType && (
                    <>
                      {selectedChart?.selectedValues?.["data_type"]?.map(
                        (chart, index) => (
                          <div style={{ marginBottom: "20px" }} key={index}>
                            <Accordion
                              classes={{ root: classes.accordionRoot }}
                              defaultExpanded
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                className={classes.summaryRoot}
                              >
                                <h4>
                                  {chart.label} (
                                  {selectedChart?.selectedValues
                                    ?.compare_preceeding
                                    ? `${selectedChart?.selectedValues.timeframe.value} v/s Preceding Period`
                                    : selectedChart?.selectedValues.timeframe
                                        .value}
                                  )
                                </h4>
                              </AccordionSummary>

                              <AccordionDetails>
                                {(chart.value === "faxes"
                                  ? uniqueFaxes
                                  : chart.value === "prescriptions"
                                  ? uniquePrescriptions
                                  : chart.value === "appointments"
                                  ? uniqueAppointments
                                  : chart.value === "reco-history"
                                  ? uniqueRecoHistory
                                  : chart.value === "reports"
                                  ? uniqueReports
                                  : chart.value === "notes"
                                  ? uniqueNotes
                                  : chart.value === "recommendations"
                                  ? uniqueRecStatues
                                  : chart.value === "sms"
                                  ? uniqueSmsStatuses
                                  : uniqueEmailStatues
                                ).length > 0 ? (
                                  <StyledTableContainer
                                    style={{
                                      width: "100%",
                                      overflowX: "auto",
                                      border: "1px solid #DFDFDF",
                                      borderCollapse: "separate",
                                      borderSpacing: 0,
                                      borderRight: "none",
                                      borderBottom: "none",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <AccordionHeaderFirstColumn>
                                          {!selectedChart?.selectedValues?.[
                                            "group_by"
                                          ]?.[chart.value] ||
                                          selectedChart?.selectedValues?.[
                                            "group_by"
                                          ]?.[chart.value].length === 0
                                            ? "Metric"
                                            : selectedChart?.selectedValues?.[
                                                "group_by"
                                              ]?.[chart.value]
                                                ?.map((itm) => itm.label)
                                                ?.sort((a, b) => {
                                                  let desiredOrderArray = "";
                                                  if (
                                                    chart?.value ===
                                                    "appointments"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderAppointments;
                                                  }
                                                  if (
                                                    chart?.value ===
                                                    "prescriptions"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderPrescriptions;
                                                  }
                                                  if (
                                                    chart?.value ===
                                                    "reco-history"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderRecoHistory;
                                                  }
                                                  if (chart?.value === "sms") {
                                                    desiredOrderArray =
                                                      desiredOrderSms;
                                                  }
                                                  if (
                                                    chart?.value === "emails"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderEmails;
                                                  }
                                                  if (
                                                    chart?.value === "notes"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderNotes;
                                                  }
                                                  if (
                                                    chart?.value ===
                                                    "recommendations"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderRecommendations;
                                                  }
                                                  if (
                                                    chart?.value === "reports"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderReports;
                                                  }
                                                  if (
                                                    chart?.value === "faxes"
                                                  ) {
                                                    desiredOrderArray =
                                                      desiredOrderFaxes;
                                                  }
                                                  return (
                                                    desiredOrderArray.indexOf(
                                                      a
                                                    ) -
                                                    desiredOrderArray.indexOf(b)
                                                  );
                                                })
                                                .join(" - ")}
                                        </AccordionHeaderFirstColumn>
                                        {selectedChart?.selectedValues
                                          ?.frequency.value === "months"
                                          ? finalData?.map((item, idx) => (
                                              <AccordionHeaderRestColumns
                                                key={idx}
                                              >
                                                <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid #DFDFDF",
                                                    padding: "10px",
                                                  }}
                                                >
                                                  {moment(item.date).format(
                                                    "MMM"
                                                  )}
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      padding: "10px 30px",
                                                      flexBasis: "50%",
                                                      borderRight: selectedChart
                                                        ?.selectedValues
                                                        ?.compare_preceeding
                                                        ? "1px solid #DFDFDF"
                                                        : "none",
                                                    }}
                                                  >
                                                    {moment(item.date).format(
                                                      "YYYY"
                                                    )}
                                                  </span>
                                                  {selectedChart?.selectedValues
                                                    ?.compare_preceeding && (
                                                    <span
                                                      style={{
                                                        padding: "10px 30px",
                                                        flexBasis: "50%",
                                                      }}
                                                    >
                                                      {moment(item.date)
                                                        .subtract(1, "year")
                                                        .format("YYYY")}
                                                    </span>
                                                  )}
                                                </div>
                                              </AccordionHeaderRestColumns>
                                            ))
                                          : selectedChart?.selectedValues
                                              ?.frequency.value === "years"
                                          ? finalData?.map((item, idx) => (
                                              <AccordionHeaderRestColumns
                                                key={idx}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      padding: "10px",
                                                      flexBasis: "50%",
                                                      borderRight: selectedChart
                                                        ?.selectedValues
                                                        ?.compare_preceeding
                                                        ? "1px solid #DFDFDF"
                                                        : "none",
                                                    }}
                                                  >
                                                    {item.date}
                                                  </span>
                                                  {selectedChart?.selectedValues
                                                    ?.compare_preceeding && (
                                                    <span
                                                      style={{
                                                        padding: "10px",
                                                        flexBasis: "50%",
                                                      }}
                                                    >
                                                      {moment(item.date, "YYYY")
                                                        .subtract(1, "years")
                                                        .format("YYYY")}
                                                    </span>
                                                  )}
                                                </div>
                                              </AccordionHeaderRestColumns>
                                            ))
                                          : selectedChart?.selectedValues
                                              ?.frequency.value === "days"
                                          ? finalData?.map((item, idx) => (
                                              <AccordionHeaderRestColumns
                                                key={idx}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      padding: "10px",
                                                      flexBasis: "50%",
                                                      borderRight: selectedChart
                                                        ?.selectedValues
                                                        ?.compare_preceeding
                                                        ? "1px solid #DFDFDF"
                                                        : "none",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {item.date}
                                                  </span>
                                                  {selectedChart?.selectedValues
                                                    ?.compare_preceeding && (
                                                    <span
                                                      style={{
                                                        padding: "10px",
                                                        flexBasis: "50%",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {moment(item.date)
                                                        .subtract(1, "years")
                                                        .format("YYYY-MM-DD")}
                                                    </span>
                                                  )}
                                                </div>
                                              </AccordionHeaderRestColumns>
                                            ))
                                          : finalData?.map((item, idx) => (
                                              <AccordionHeaderRestColumns
                                                key={idx}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      padding: "10px",
                                                      flexBasis: "50%",
                                                      borderRight: selectedChart
                                                        ?.selectedValues
                                                        ?.compare_preceeding
                                                        ? "1px solid #DFDFDF"
                                                        : "none",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {item.date
                                                      .split(" - ")
                                                      .map((date) =>
                                                        moment(
                                                          date,
                                                          "DD MMM YYYY"
                                                        ).format("YYYY-MM-DD")
                                                      )
                                                      .join(" - ")}
                                                  </span>
                                                  {selectedChart?.selectedValues
                                                    ?.compare_preceeding && (
                                                    <span
                                                      style={{
                                                        padding: "10px",
                                                        flexBasis: "50%",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {item.date
                                                        .split(" - ")
                                                        .map((date) =>
                                                          moment(
                                                            date,
                                                            "DD MMM YYYY"
                                                          )
                                                            .subtract(1, "year")
                                                            .format(
                                                              "YYYY-MM-DD"
                                                            )
                                                        )
                                                        .join(" - ")}
                                                    </span>
                                                  )}
                                                </div>
                                              </AccordionHeaderRestColumns>
                                            ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(chart.value === "faxes"
                                        ? uniqueFaxes
                                        : chart.value === "prescriptions"
                                        ? uniquePrescriptions
                                        : chart.value === "appointments"
                                        ? uniqueAppointments
                                        : chart.value === "reco-history"
                                        ? uniqueRecoHistory
                                        : chart.value === "reports"
                                        ? uniqueReports
                                        : chart.value === "notes"
                                        ? uniqueNotes
                                        : chart.value === "recommendations"
                                        ? uniqueRecStatues
                                        : chart.value === "sms"
                                        ? uniqueSmsStatuses
                                        : uniqueEmailStatues
                                      ).map((itm, itmIdx, arr) => (
                                        <tr key={itmIdx}>
                                          <AccordionBodyFirstColumn
                                            borderBottom={
                                              itmIdx === arr.length - 1
                                                ? "1px solid #dfdfdf"
                                                : "none"
                                            }
                                          >
                                            {itm === "" ? "empty" : itm}
                                          </AccordionBodyFirstColumn>
                                          {finalData?.map((item, idx) => (
                                            <AccordionBodyRestColumn key={idx}>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    padding: "10px",
                                                    flexBasis: "50%",
                                                    borderRight: selectedChart
                                                      ?.selectedValues
                                                      ?.compare_preceeding
                                                      ? "1px solid #DFDFDF"
                                                      : "none",
                                                  }}
                                                >
                                                  {!selectedChart
                                                    ?.selectedValues[
                                                    "group_by"
                                                  ][chart.value] ||
                                                  selectedChart
                                                    ?.selectedValues?.[
                                                    "group_by"
                                                  ][chart.value]?.length === 0
                                                    ? item[
                                                        `${
                                                          chart.value ===
                                                          "reco-history"
                                                            ? "Reco-history"
                                                            : chart.label
                                                        }: ${
                                                          selectedChart
                                                            ?.selectedValues
                                                            .timeframe.value
                                                        }`
                                                      ] ?? 0
                                                    : item[
                                                        `${
                                                          chart.value ===
                                                          "reco-history"
                                                            ? "Reco-history"
                                                            : chart.label
                                                        }: ${
                                                          selectedChart
                                                            ?.selectedValues
                                                            .timeframe.value
                                                        } (${itm})`
                                                      ] ?? 0}
                                                </span>
                                                {selectedChart?.selectedValues
                                                  ?.compare_preceeding && (
                                                  <span
                                                    style={{
                                                      padding: "10px",
                                                      flexBasis: "50%",
                                                    }}
                                                  >
                                                    {!selectedChart
                                                      ?.selectedValues[
                                                      "group_by"
                                                    ][chart.value] ||
                                                    selectedChart
                                                      ?.selectedValues?.[
                                                      "group_by"
                                                    ][chart.value]?.length === 0
                                                      ? item[
                                                          `${
                                                            chart.value ===
                                                            "reco-history"
                                                              ? "Reco-history"
                                                              : chart.label
                                                          }: Preceding period`
                                                        ] ?? 0
                                                      : item[
                                                          `${
                                                            chart.value ===
                                                            "reco-history"
                                                              ? "Reco-history"
                                                              : chart.label
                                                          }: Preceding period (${itm})`
                                                        ] ?? 0}
                                                  </span>
                                                )}
                                              </div>
                                            </AccordionBodyRestColumn>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </StyledTableContainer>
                                ) : (
                                  <span>No Data</span>
                                )}
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        )
                      )}
                    </>
                  )}

                {(selectedBarChart || selectedLineChart) &&
                  selectedIndividualFlowType &&
                  (noGroupBySelected ? (
                    <StyledTableContainer
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        border: "1px solid #DFDFDF",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                      }}
                    >
                      <table style={{ marginBottom: "0px" }}>
                        <thead>
                          <tr>
                            <th style={{ padding: "10px" }}>
                              {selectedChart?.selectedValues?.data_type.label}
                            </th>
                            {data?.map((item, index) => (
                              <th
                                style={{ padding: "10px", textAlign: "center" }}
                                key={index}
                              >
                                {item.date}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ padding: "10px" }}>
                              {" "}
                              {selectedChart?.selectedValues["data_subset"]
                                ?.value === "charge"
                                ? "Revenue"
                                : "Count"}
                            </td>
                            {data?.map((item, index) => (
                              <td
                                style={{ padding: "10px", textAlign: "center" }}
                                key={index}
                              >
                                {selectedChart?.selectedValues["data_subset"]
                                  ?.value === "charge"
                                  ? `$${
                                      item.data?.[0]?.id__count?.toLocaleString(
                                        "en-US"
                                      ) || 0
                                    }`
                                  : item.data?.[0]?.id__count || 0}
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </StyledTableContainer>
                  ) : (
                    <div
                      style={{
                        width: 0,
                        minWidth: "100%",
                        overflowX: "auto",
                        borderLeft: "1px solid #dfdfdf",
                        borderRight: "1px solid #dfdfdf",
                        boxShadow: "none",
                      }}
                    >
                      <StyledTableContainer
                        style={{
                          width: "100%",
                          overflowX: "auto",
                          border: "1px solid #DFDFDF",
                          borderCollapse: "separate",
                          borderSpacing: 0,
                          borderRight: "none",
                          borderBottom: "none",
                          marginBottom: "0px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                padding: "10px",
                                position: "sticky",
                                left: 0,
                                zIndex: 1,
                                borderRight: "1px solid #DFDFDF",
                                position: "sticky",
                                background: "white",
                                boxShadow: "inset 0px -1px #dfdfdf",
                              }}
                            >
                              {selectedChart?.selectedValues?.["group_by"]
                                .map((itm) => itm.label)
                                .sort((a, b) => {
                                  let desiredOrderArray = "";
                                  if (selectedAppointmentsDataType) {
                                    desiredOrderArray =
                                      desiredOrderAppointments;
                                  }
                                  if (selectedPrescriptionsDataType) {
                                    desiredOrderArray =
                                      desiredOrderPrescriptions;
                                  }
                                  if (selectedRecoHistoryDataType) {
                                    desiredOrderArray = desiredOrderRecoHistory;
                                  }
                                  if (selectedSmsDataType) {
                                    desiredOrderArray = desiredOrderSms;
                                  }
                                  if (selectedEmailsDataType) {
                                    desiredOrderArray = desiredOrderEmails;
                                  }
                                  if (selectedNotesDataType) {
                                    desiredOrderArray = desiredOrderNotes;
                                  }
                                  if (selectedRecommendationsDataType) {
                                    desiredOrderArray =
                                      desiredOrderRecommendations;
                                  }
                                  if (selectedReportsDataType) {
                                    desiredOrderArray = desiredOrderReports;
                                  }
                                  if (selectedReportsDataType) {
                                    desiredOrderArray = desiredOrderFaxes;
                                  }
                                  return (
                                    desiredOrderArray.indexOf(a) -
                                    desiredOrderArray.indexOf(b)
                                  );
                                })
                                .join(" - ")}
                            </th>
                            {flattenData?.map((item, index) => (
                              <th
                                style={{
                                  padding: "10px",
                                  whiteSpace: "nowrap",
                                  textAlign: "center",
                                  borderRight: "1px solid #DFDFDF",
                                  borderBottom: "1px solid #DFDFDF",
                                }}
                                key={index}
                              >
                                {item.date}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {uniqueStatuses.map((status, statusIndex) => (
                            <tr key={statusIndex}>
                              <td
                                style={{
                                  padding: "10px",
                                  fontWeight: 600,
                                  position: "sticky",
                                  left: 0,
                                  backgroundColor: "#fff",
                                  zIndex: 1,
                                  textAlign: "left",
                                  borderRight: "1px solid #DFDFDF",
                                  position: "sticky",
                                  zIndex: "1",
                                  background: "white",
                                  left: 0,
                                  fontWeight: 600,
                                  whiteSpace: "nowrap",
                                  boxShadow: "0px -1px #dfdfdf",
                                  borderBottom:
                                    statusIndex === uniqueStatuses.length - 1
                                      ? "1px solid #dfdfdf"
                                      : "none",
                                }}
                              >
                                {status}
                              </td>
                              {flattenData?.map((item, index) => (
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    borderRight: "1px solid #DFDFDF",
                                    borderBottom: "1px solid #DFDFDF",
                                  }}
                                  key={index}
                                >
                                  {item[status] || 0}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </StyledTableContainer>
                    </div>
                  ))}

                {(selectedPieChart || selectedGaugeChart) && (
                  <StyledTableContainer
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      border: "1px solid #DFDFDF",
                      borderRadius: "8px",
                    }}
                  >
                    <table style={{ marginBottom: "0px" }}>
                      <thead>
                        <tr>

                          <th style={{ padding: "10px" }}>{selectedChart?.selectedValues?.["group_by"]
                                .map((itm) => itm.label)
                                .sort((a, b) => {
                                  let desiredOrderArray = "";
                                  if (selectedPatientsDataType) {
                                    desiredOrderArray =
                                      desiredOrderPatients;
                                  }
                                  if(selectedReferrersDataType) {
                                    desiredOrderArray =
                                      desiredOrderReferrers;
                                  }
                                  if(selectedRadiologistsDataType) {
                                    desiredOrderArray =
                                      desiredOrderRadiologists;
                                  }
                                  if(selectedRecommendationPieDataType) {
                                    desiredOrderArray =
                                      desiredOrderRecommendationsPie;
                                  }
                                  return (
                                    desiredOrderArray.indexOf(a) -
                                    desiredOrderArray.indexOf(b)
                                  );
                                })
                                .join(" - ")}</th>
                          <th style={{ padding: "10px" }}>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pieChartDataTable(data, selectedChart).map((status, statusIndex) => (
                          <tr key={statusIndex}>
                            <td
                              style={{ padding: "10px" }}
                            >{`${status?.label}`}</td>

                            <td style={{ padding: "10px" }}>
                              {status?.id__count}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </StyledTableContainer>
                )}
              </>
            )
          )}
        </CustomChartBox>
      )}
      {editing.visible && (
        <EditModal
          selectedValues={editing.data}
          opened={editing.visible}
          onClose={() => setEditing({ visible: false, data: {} })}
          setCustomCharts={setCustomCharts}
          setSelectedChart={setSelectedChart}
          selectedChart={selectedChart}
        />
      )}
    </Container>
  );
};

export default React.memo(CustomCharts);
